import React, { useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Collapse,
  IconButton,
  Typography,
  Chip,
  Box,
  Divider,
  Card,
  CardContent,
  Grid,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import PhoneIcon from "@mui/icons-material/Phone";
import PhoneMissedIcon from "@mui/icons-material/PhoneMissed";
import PhoneDisabledIcon from "@mui/icons-material/PhoneDisabled";
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CommentIcon from "@mui/icons-material/Comment";
import BusinessIcon from "@mui/icons-material/Business";
import EventIcon from "@mui/icons-material/Event"; // event/date marker
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";
import { AGENT_OUTGOING_CALL } from "../../../../constants";
import CallIcon from "@mui/icons-material/Call";

function NotConnectedCallTable({
  filters,
  outgoingMissed,
  setLoading,
  missedFilters,
  setMissedFilters,
  setFilters,
}) {
  const empDetails = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const [totalCount, setTotalCount] = useState(0);
  const [openRows, setOpenRows] = useState([]); // To manage which rows are expanded

  const calls = outgoingMissed?.missedCalls || [];
  const totalRecords = outgoingMissed?.pagination?.totalRecords || 0;
  const currentPage = outgoingMissed?.pagination?.page || missedFilters.page;
  const pageSize =
    outgoingMissed?.pagination?.pageSize || missedFilters.pageSize;

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setMissedFilters((prev) => ({ ...prev, page: newPage + 1 })); // API expects 1-based
  };

  const handleChangeRowsPerPage = (event) => {
    setMissedFilters((prev) => ({
      ...prev,
      pageSize: parseInt(event.target.value, 10),
      page: 1,
    }));
  };

  // Filter states
  const [mobileFilter, setMobileFilter] = useState("");
  const [stateFilter, setStateFilter] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const { agentName, agentNo } = useParams();

  const [callData, setCallData] = useState([]);

  // State options for dropdown
  const stateOptions = [
    "AP",
    "OD",
    "TN",
    "RJ",
    "GJ",
    "HR",
    "PN",
    "KT",
    "WB",
    "CG",
  ];

  const [missedCallId, setMissedCallId] = useState(null); //

  // const fetchConnectedData = () => {
  //   const { startDate, endDate } = filters;

  //   // Determine yesterday's date
  //   const yesterday = dayjs().subtract(1, "day").format("YYYY-MM-DD");

  //   // Format startDate and endDate, defaulting to yesterday if not provided
  //   const formattedStartDate = startDate
  //     ? dayjs(startDate).format("YYYY-MM-DD")
  //     : yesterday;
  //   const formattedEndDate = endDate
  //     ? dayjs(endDate).format("YYYY-MM-DD")
  //     : yesterday;

  //   // Build query params
  //   const queryParams = new URLSearchParams();
  //   queryParams.append("startDate", formattedStartDate);
  //   queryParams.append("endDate", formattedEndDate);

  // //   if (localStorage.getItem("empRole") === "1") {
  // //     queryParams.append("agentNumber", empDetails?.EmployeePhone);
  // //   } else {
  // //     queryParams.append("agentNumber", 7880162561); // Default agent number (Pollai Hari)
  // //   }
  //   if (localStorage.getItem("empRole") === "1") {
  //     queryParams.append("agentNumber", empDetails?.EmployeePhone);
  //   }

  //   queryParams.append("callStatus", "NotConnected");
  //   queryParams.append("page", page + 1); // Current page (1-based index)
  //   queryParams.append("pageSize", rowsPerPage); // Number of rows per page

  //   // Add filter parameters
  //   if (mobileFilter.trim()) {
  //     queryParams.append("bPartyNo", mobileFilter.trim());
  //   }
  //   if (stateFilter) {
  //     queryParams.append("state", stateFilter);
  //   }

  //   setLoading(true);
  //   axios
  //     .get(`${AGENT_OUTGOING_CALL}?${queryParams.toString()}`)
  //     .then((response) => {
  //       console.log(response);
  //       const { notConnected, pagination, summary } = response.data;
  //       setMetricData(summary);
  //       setCallData(notConnected.calls); // Update the call data
  //       setTotalCount(pagination.totalRecords); // Update the total record count
  //       if ((page * rowsPerPage) >= pagination.totalRecords && page !== 0) {
  //         setPage(0);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching not connected data:", error);
  //       setCallData([]); // Set call data to empty on error
  //       setLoading(false);
  //     });
  // };

  //   useEffect(() => {
  //     fetchConnectedData();
  //   }, [filters, page, rowsPerPage, mobileFilter, stateFilter]);

  // Handle row expansion toggle

  const handleRowToggle = (index) => {
    setOpenRows((prev) => {
      if (prev.includes(index)) {
        // alert("closed");
        return prev.filter((rowIndex) => rowIndex !== index);
      } else {
        // alert("opened");
        return [...prev, index];
      }
    });
  };

  function formatDateTimeCompact(isoString) {
    // Parse using Date constructor
    const date = new Date(isoString);

    if (isNaN(date)) return "-"; // fallback if invalid date

    // Get date parts
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed
    const year = String(date.getUTCFullYear()).slice(-2); // last 2 digits

    // Get time parts
    let hours = date.getUTCHours();
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // convert 0 to 12

    return `${day}-${month}-${year}, ${hours}:${minutes}${ampm}`;
  }

  // Handle filter clear
  const handleClearFilters = () => {
    setMobileFilter("");
    setStateFilter("");
    setPage(0); // Reset to first page
  };

  // Handle mobile filter change
  const handleMobileFilterChange = (event) => {
    setMobileFilter(event.target.value);
    setPage(0); // Reset to first page when filter changes
  };

  // Handle state filter change
  const handleStateFilterChange = (event) => {
    setStateFilter(event.target.value);
    setPage(0); // Reset to first page when filter changes
  };

  const formatDate = (dateString) =>
    moment(dateString).format("DD-MM-YYYY HH:mm:ss");

  const IconCell = ({ row }) => (
    <Button
      variant="contained"
      size="small"
      startIcon={<CallIcon />}
      onClick={() => handleCallIconClick(row)}
      color="warning"
      sx={{
        minWidth: "auto",
        px: 1.5,
        py: 0.5,
        borderRadius: 2,
        fontSize: "0.75rem",
        fontWeight: 600,
        textTransform: "none",
        boxShadow: 1,
        "&:hover": {
          boxShadow: 2,
          transform: "translateY(-1px)",
        },
        transition: "all 0.2s ease",
      }}
    >
      Retry Call
    </Button>
  );
  const handleCallIconClick = (row) => {
    // customer number (b-party / lead mobile)
    const mobNo = row?.leadDetail?.MobileNo || row?.bPartyNo || "";

    // caller / agent number (a-party / agent phone / current user)
    const callerNumber =
      row?.aPartyNo ||
      row?.agent?.EmployeePhone ||
      empDetails?.EmployeePhone ||
      "";

    const missedCallId = String(row?.callId || "");

    // keep your original keys so caller component doesn't break
    localStorage.setItem("missedCallId", missedCallId);

    navigate("/dashboard", {
      state: {
        mobNo,
        lotNum: callerNumber, // <-- previously row.callerNumber (not in new payload)
        missedCallId,
      },
    });
  };

  const InfoItem = ({ icon, label, value }) => (
    <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          minWidth: 140,
          color: "text.secondary",
          fontSize: "0.875rem",
          fontWeight: 500,
        }}
      >
        {icon}
        <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
          {label}:
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ ml: 1, fontWeight: 400 }}>
        {value || "-"}
      </Typography>
    </Box>
  );

  return (
    <>
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
        {/* Filter Section */}
        <Box
          sx={{
            p: 2,
            backgroundColor: "warning.50",
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: showFilters ? 2 : 0,
            }}
          >
            <Typography
              variant="h6"
              sx={{ display: "flex", alignItems: "center", fontWeight: 600 }}
            >
              <PhoneDisabledIcon sx={{ mr: 1, color: "warning.main" }} />
              Outgoing Not Connected Calls
            </Typography>
            {/* <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setShowFilters(!showFilters)}
              size="small"
              color="warning"
              sx={{ textTransform: 'none' }}
            >
              {showFilters ? 'Hide Filters' : 'Show Filters'}
            </Button> */}
          </Box>

          <Collapse in={showFilters}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <TextField
                label="Mobile Number"
                value={mobileFilter}
                onChange={handleMobileFilterChange}
                placeholder="Enter mobile number"
                size="small"
                InputProps={{
                  startAdornment: (
                    <SearchIcon sx={{ mr: 1, color: "text.secondary" }} />
                  ),
                }}
                sx={{ minWidth: 200 }}
              />

              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>State</InputLabel>
                <Select
                  value={stateFilter}
                  onChange={handleStateFilterChange}
                  label="State"
                >
                  <MenuItem value="">
                    <em>All States</em>
                  </MenuItem>
                  {stateOptions.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {(mobileFilter || stateFilter) && (
                <Button
                  variant="outlined"
                  startIcon={<ClearIcon />}
                  onClick={handleClearFilters}
                  size="small"
                  color="error"
                  sx={{ textTransform: "none" }}
                >
                  Clear Filters
                </Button>
              )}
            </Box>

            {/* Active filters display */}
            {(mobileFilter || stateFilter) && (
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary", mr: 1 }}
                >
                  Active Filters:
                </Typography>
                {mobileFilter && (
                  <Chip
                    label={`Mobile: ${mobileFilter}`}
                    size="small"
                    color="warning"
                    variant="outlined"
                    onDelete={() => setMobileFilter("")}
                  />
                )}
                {stateFilter && (
                  <Chip
                    label={`State: ${stateFilter}`}
                    size="small"
                    color="warning"
                    variant="outlined"
                    onDelete={() => setStateFilter("")}
                  />
                )}
              </Box>
            )}
          </Collapse>
        </Box>

        <TableContainer component={Paper} elevation={0}>
          <Table
            sx={{
              minWidth: 650,
              height: "100%",
              tableLayout: "fixed",
            }}
            aria-label="not connected calls table"
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "warning.main",
                  "& .MuiTableCell-head": {
                    color: "white",
                    fontWeight: 600,
                    fontSize: "0.875rem",
                  },
                }}
              >
                <TableCell width={60} sx={{ textAlign: "center" }} />
                {/* <TableCell width={60} sx={{ textAlign: "center", padding: 2 }}>S.No</TableCell> */}
                {/* <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        Call Type
      </Box>
    </TableCell> */}
                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PersonIcon sx={{ mr: 1, fontSize: 18 }} />
                    Customer Name
                  </Box>
                </TableCell>
                <TableCell width={150} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CallIcon sx={{ mr: 1, fontSize: 18 }} />
                    Mobile Number
                  </Box>
                </TableCell>
                <TableCell width={120} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LocationOnIcon sx={{ mr: 1, fontSize: 18 }} />
                    Region
                  </Box>
                </TableCell>

                {/* NEW: Category */}
                <TableCell width={120} sx={{ textAlign: "center", padding: 2 }}>
                  Category
                </TableCell>

                {/* NEW: Sub Category */}
                <TableCell width={140} sx={{ textAlign: "center", padding: 2 }}>
                  Sub Category
                </TableCell>
                {/* NEW: Sub Category */}
                <TableCell width={140} sx={{ textAlign: "center", padding: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <EventIcon sx={{ mr: 1, fontSize: 18 }} />
                    Date
                  </Box>
                </TableCell>

                {/* Action (sticky) */}
                <TableCell
                  align="center"
                  sx={{
                    textAlign: "center",
                    width: "120px",
                    position: "sticky",
                    right: 0,
                    backgroundColor: "warning.main",
                    zIndex: 100,
                    boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
                    padding: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CallIcon sx={{ mr: 1, fontSize: 18 }} />
                    Action
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {Array.isArray(calls) && calls.length > 0 ? (
                calls.map((row, rowIndex) => (
                  <React.Fragment key={rowIndex}>
                    <TableRow
                      sx={{
                        "&:hover": { backgroundColor: "action.hover" },
                        backgroundColor:
                          rowIndex % 2 === 0 ? "grey.50" : "white",
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      {/* Expand button -----------------------------> */}

                      <TableCell sx={{ padding: 1 }}>
                        <IconButton
                          onClick={() => handleRowToggle(rowIndex)}
                          // onClick={()=>alert(rowIndex)}
                          sx={{
                            padding: 1,
                            transition: "transform 0.2s ease",
                            "&:hover": {
                              backgroundColor: "warning.main",
                              color: "white",
                              transform: "scale(1.1)",
                            },
                          }}
                        >
                          {openRows.includes(rowIndex) ? (
                            <ExpandLessIcon />
                          ) : (
                            <ExpandMoreIcon />
                          )}
                        </IconButton>
                      </TableCell>

                      {/* S.No */}
                      {/* <TableCell sx={{ textAlign: "center", padding: 2, fontWeight: 500 }}>
            <Chip
               label={(currentPage - 1) * pageSize + (rowIndex + 1)}
              size="small"
              variant="outlined"
              color="primary"
            />
          </TableCell> */}

                      {/* Call Type (from leadDetail) */}
                      {/* <TableCell sx={{ textAlign: "center", padding: 2, fontWeight: 500 }}>
            {row.leadDetail?.call_type || "-"}
          </TableCell> */}

                      {/* Customer Name */}

                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontWeight: 500,
                        }}
                      >
                        {row.leadDetail?.CustomerName || "-"}
                      </TableCell>

                      {/* Mobile Number */}
                      <TableCell sx={{ textAlign: "center", padding: 2 }}>
                        {row.leadDetail?.MobileNo || row.bPartyNo || "-"}
                      </TableCell>

                      {/* Region */}
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontWeight: 500,
                        }}
                      >
                        {row.leadDetail?.region_name || "-"}
                      </TableCell>

                      {/* Category */}
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontSize: "0.875rem",
                        }}
                      >
                        {row.leadDetail?.category || "-"}
                      </TableCell>

                      {/* Sub Category */}
                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontSize: "0.875rem",
                        }}
                      >
                        {row.leadDetail?.sub_category || "-"}
                      </TableCell>

                      <TableCell
                        sx={{
                          textAlign: "center",
                          padding: 2,
                          fontWeight: 500,
                        }}
                      >
                        {/* "bb" */}
                        {formatDateTimeCompact(row.callStartTime) || "-"}
                      </TableCell>

                      {/* Action (sticky right) */}
                      <TableCell
                        align="center"
                        sx={{
                          width: "120px",
                          position: "sticky",
                          right: 0,
                          backgroundColor:
                            rowIndex % 2 === 0 ? "grey.50" : "white",
                          zIndex: 10,
                          boxShadow: "-2px 0 4px rgba(0,0,0,0.1)",
                          padding: 2,
                        }}
                      >
                        <IconCell row={row} />
                      </TableCell>
                    </TableRow>
                    {/* Expanded Details row
            colSpan = total columns except the sticky Action column.
            We have: Expand + S.No + Call Type + Name + Mobile + Region + Category + SubCategory + Action = 9
            So set colSpan to 8.
        */}{" "}
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{ paddingBottom: 0, paddingTop: 0, border: 0 }}
                      >
                        <Collapse
                          in={openRows.includes(rowIndex)}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Box sx={{ margin: 2 }}>
                            <Card elevation={1} sx={{ borderRadius: 2 }}>
                              <CardContent sx={{ p: 3 }}>
                                <Typography
                                  variant="h6"
                                  sx={{
                                    mb: 2,
                                    color: "warning.main",
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <PersonIcon sx={{ mr: 1 }} />
                                  Customer Details
                                </Typography>
                                <Divider sx={{ mb: 2 }} />

                                <Grid container spacing={3}>
                                  <Grid item xs={12} md={6}>
                                    {/* <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Farmer Village"
                                      value={row.shrimpFeedDetails?.farmerVillage}
                                    /> */}
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Region"
                                      value={row.leadDetail?.region_name}
                                    />
                                    {/* <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Zone"
                                      value={row.leadDetail?.Zone}
                                    /> */}
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="State"
                                      value={row.leadDetail?.state_name}
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <InfoItem
                                      icon={<LocationOnIcon fontSize="small" />}
                                      label="Postal Code"
                                      value={row.leadDetail?.pincode}
                                    />
                                    <InfoItem
                                      icon={<CommentIcon fontSize="small" />}
                                      label="Remarks"
                                      value={row.leadDetail?.agent_remark}
                                    />
                                    {/* <InfoItem
                                      icon={<CommentIcon fontSize="small" />}
                                      label="Feed Type"
                                      value={row.shrimpFeedDetails?.feedType}
                                    /> */}
                                    {/* <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                      <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        minWidth: 140,
                                        color: 'text.secondary',
                                        fontSize: '0.875rem',
                                        fontWeight: 500
                                      }}>
                                        <CommentIcon fontSize="small" />
                                        <Typography variant="body2" sx={{ ml: 1, fontWeight: 500 }}>
                                          Status:
                                        </Typography>
                                      </Box>
                                      <Chip
                                        label={row.shrimpFeedDetails?.status || "-"}
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                        sx={{ ml: 1, textTransform: 'capitalize' }}
                                      />
                                    </Box> */}
                                  </Grid>
                                </Grid>

                                <Typography
                                  variant="h6"
                                  sx={{
                                    mt: 3,
                                    mb: 2,
                                    color: "warning.main",
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <CommentIcon sx={{ mr: 1 }} />
                                  Remarks
                                </Typography>
                                <Divider sx={{ mb: 2 }} />

                                {Array.isArray(row.agentCallDetails?.remarks) &&
                                row.agentCallDetails.remarks.length > 0 ? (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 2,
                                    }}
                                  >
                                    {row.agentCallDetails.remarks.map(
                                      (remark, idx) => (
                                        <Card
                                          key={remark.id || idx}
                                          elevation={0}
                                          sx={{
                                            backgroundColor: "grey.50",
                                            border: "1px solid",
                                            borderColor: "grey.200",
                                            borderRadius: 2,
                                          }}
                                        >
                                          <CardContent sx={{ p: 2 }}>
                                            <Grid container spacing={2}>
                                              <Grid item xs={12} md={6}>
                                                <InfoItem
                                                  label="Name"
                                                  value={remark.name}
                                                />
                                                <InfoItem
                                                  label="Type"
                                                  value={remark.type}
                                                />
                                                <InfoItem
                                                  label="Pond Location"
                                                  value={remark.pondLocation}
                                                />
                                                <InfoItem
                                                  label="Category"
                                                  value={
                                                    remark.prospectFarmerCategory
                                                  }
                                                />
                                                <InfoItem
                                                  label="District"
                                                  value={remark.district}
                                                />
                                                <InfoItem
                                                  label="Current Feed Used"
                                                  value={remark.currentFeedUsed}
                                                />
                                                <InfoItem
                                                  label="Fish Species"
                                                  value={remark.fishSpecies}
                                                />
                                                <InfoItem
                                                  label="Number of Ponds"
                                                  value={remark.numberOfPonds}
                                                />
                                                <InfoItem
                                                  label="Area of Ponds (acres)"
                                                  value={remark.pondAreaInAcres}
                                                />
                                                <InfoItem
                                                  label="Stocking (Yes/No)"
                                                  value={remark.isStocking}
                                                />
                                              </Grid>
                                              <Grid item xs={12} md={6}>
                                                <InfoItem
                                                  label="Stocking Density"
                                                  value={remark.stockingDensity}
                                                />
                                                <InfoItem
                                                  label="Days of Culture"
                                                  value={remark.daysOfCulture}
                                                />
                                                <InfoItem
                                                  label="Harvesting (Yes/No)"
                                                  value={remark.isHarvesting}
                                                />
                                                <InfoItem
                                                  label="Harvesting Quantity"
                                                  value={
                                                    remark.harvestingQuantity
                                                  }
                                                />
                                                <InfoItem
                                                  label="Potential (MT)"
                                                  value={
                                                    remark.potentialityInMT
                                                  }
                                                />
                                                <InfoItem
                                                  label="Status"
                                                  value={remark.status}
                                                />
                                                <InfoItem
                                                  label="Purpose"
                                                  value={remark.purpose}
                                                />
                                                <InfoItem
                                                  label="Agent Remarks"
                                                  value={remark.agentRemarks}
                                                />
                                                <InfoItem
                                                  label="Call Type"
                                                  value={remark.callType}
                                                />
                                                <InfoItem
                                                  label="FollowUp Date"
                                                  value={
                                                    remark.followUpDate
                                                      ? moment(
                                                          remark.followUpDate
                                                        ).format(
                                                          "DD-MM-YYYY HH:mm:ss"
                                                        )
                                                      : "-"
                                                  }
                                                />
                                                <InfoItem
                                                  label="Created At"
                                                  value={
                                                    remark.createdAt
                                                      ? moment(
                                                          remark.createdAt
                                                        ).format(
                                                          "DD-MM-YYYY HH:mm:ss"
                                                        )
                                                      : "-"
                                                  }
                                                />
                                              </Grid>
                                            </Grid>
                                          </CardContent>
                                        </Card>
                                      )
                                    )}
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      textAlign: "center",
                                      py: 3,
                                      color: "text.secondary",
                                      backgroundColor: "grey.50",
                                      borderRadius: 2,
                                      border: "1px dashed",
                                      borderColor: "grey.300",
                                    }}
                                  >
                                    <CommentIcon
                                      sx={{ fontSize: 48, mb: 1, opacity: 0.5 }}
                                    />
                                    <Typography variant="body1">
                                      No remarks available
                                    </Typography>
                                  </Box>
                                )}
                              </CardContent>
                            </Card>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 6 }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        paddingLeft: "500px",
                        alignItems: "center",
                        color: "text.secondary",
                      }}
                    >
                      <PhoneMissedIcon
                        sx={{
                          fontSize: 64,
                          mb: 2,
                          opacity: 0.3,
                          color: "error.main",
                        }}
                      />
                      <Typography variant="h6" sx={{ mb: 1 }}>
                        No Missed Calls
                      </Typography>
                      <Typography variant="body2">
                        There are no missed calls to display for the selected
                        period.
                      </Typography>
                      {(mobileFilter || stateFilter) && (
                        <Typography
                          variant="body2"
                          sx={{ mt: 1, fontStyle: "italic" }}
                        >
                          Try adjusting your filters to see more results.
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalRecords} // total unique calls
          page={currentPage - 1} // convert to 0-based
          onPageChange={handleChangePage}
          rowsPerPage={pageSize}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            borderTop: "1px solid",
            borderColor: "divider",
            backgroundColor: "grey.50",
          }}
        />
      </Paper>
    </>
  );
}

export default NotConnectedCallTable;
